import React from 'react'

export default function Figure (props) {
  return (
    <figure className={props.figClass}>
      <img src={props.imgSrc} id={props.imgId} alt={props.imgAlt} />
      <figcaption className={props.capClass}>{props.capContent}</figcaption>
    </figure>
  )
}



// WEBPACK FOOTER //
// ./components/Figure.js